var _style, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000167389294630389633970000003598499093153337239_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 5.5,
    y: 5.5,
    width: 68.99,
    height: 68.99
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096762665886917216050000007279649209107560860_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g145",
    style: {
      clipPath: "url(#SVGID_00000096762665886917216050000007279649209107560860_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g151",
    transform: "translate(70.9409,97.6699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path153"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-29.88-31.03h-23.85c-1.74,0-3.15-1.42-3.15-3.16v-2.15c0-0.56,0.45-1.01,1.01-1.01s1.01,0.45,1.01,1.01v2.15 c0,0.63,0.51,1.13,1.13,1.13h23.85c0.56,0,1.01,0.45,1.01,1.01S-29.32-31.03-29.88-31.03z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g155",
    transform: "translate(358.7808,472.6201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path157"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-300.49-431.16c-0.56,0-1.01-0.45-1.01-1.01v-27.5c0-0.63-0.51-1.13-1.13-1.13h-2.29c-0.56,0-1.01-0.45-1.01-1.01 s0.45-1.01,1.01-1.01h2.29c1.74,0,3.16,1.42,3.16,3.16v27.5C-299.48-431.61-299.93-431.16-300.49-431.16z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g159",
    transform: "translate(157.1831,504.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-103.33-458.32c-0.56,0-1.01-0.45-1.01-1.01v-36.51c0-0.63-0.51-1.13-1.13-1.13h-25.02c-0.56,0-1.01-0.45-1.01-1.01 s0.45-1.01,1.01-1.01h25.02c1.74,0,3.16,1.42,3.16,3.16v36.51C-102.32-458.77-102.77-458.32-103.33-458.32z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g163",
    transform: "translate(263.8608,97.6699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path165"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-222.8-35.32h-28.29c-1.74,0-3.16-1.42-3.16-3.16v-41.36c0-0.56,0.45-1.01,1.01-1.01s1.01,0.45,1.01,1.01v41.36 c0,0.63,0.51,1.13,1.13,1.13h28.29c0.56,0,1.01,0.45,1.01,1.01S-222.24-35.32-222.8-35.32z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g167",
    transform: "translate(432.292,7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-368.54,67h-17.08c-3.66,0-6.63-2.97-6.63-6.63V43.29c0-3.66,2.97-6.63,6.63-6.63h17.08c3.66,0,6.63,2.97,6.63,6.63 v17.08C-361.91,64.02-364.88,67-368.54,67z M-385.61,38.68c-2.54,0-4.61,2.07-4.61,4.61v17.08c0,2.54,2.07,4.61,4.61,4.61 h17.08c2.54,0,4.61-2.07,4.61-4.61V43.29c0-2.54-2.07-4.61-4.61-4.61H-385.61z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g171",
    transform: "translate(421.4478,128.0117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path173"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-364.27-58.31h-3.93c-1.26,0-2.29-1.03-2.29-2.29v-5.27h-0.96c-1.28,0.04-2.45-0.7-3.04-1.93s-0.43-2.62,0.41-3.62 l5.05-6.3c0.68-0.85,1.7-1.34,2.79-1.34s2.11,0.49,2.79,1.34l5.06,6.31c0.84,1,0.99,2.38,0.4,3.6 c-0.59,1.23-1.77,1.97-3.07,1.93h-0.93v5.27C-361.97-59.34-363-58.31-364.27-58.31z M-369.48-67.89c0.56,0,1.01,0.45,1.01,1.01 v6.28c0,0.15,0.12,0.27,0.27,0.27h3.93c0.15,0,0.27-0.12,0.27-0.27v-6.28c0-0.56,0.45-1.01,1.01-1.01h1.97 c0.01,0,0.03,0,0.04,0c0.75,0,1.09-0.6,1.18-0.79c0.19-0.39,0.25-0.98-0.13-1.43c0-0.01-0.01-0.01-0.02-0.02l-5.07-6.32 c-0.6-0.74-1.84-0.74-2.44,0l-5.07,6.32c-0.4,0.48-0.34,1.06-0.15,1.45c0.09,0.19,0.45,0.79,1.19,0.79H-369.48z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g175",
    transform: "translate(38.0024,420.5322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path177"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18.19-401.69h-9.19c-0.41,0-0.78-0.25-0.93-0.62c-0.16-0.38-0.07-0.81,0.22-1.1l11.33-11.32 c0.29-0.29,0.72-0.37,1.1-0.22c0.38,0.16,0.62,0.52,0.62,0.93v9.17C-15.03-403.11-16.45-401.69-18.19-401.69z M-24.94-403.71 h6.75c0.62,0,1.13-0.51,1.13-1.13v-6.73L-24.94-403.71z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g179",
    transform: "translate(245.9995,427.4292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-207.35-409.52h-9.49c-1.77,0-3.22-1.44-3.22-3.22s1.44-3.22,3.22-3.22h9.49c1.77,0,3.22,1.44,3.22,3.22 S-205.57-409.52-207.35-409.52z M-216.84-413.94c-0.66,0-1.2,0.54-1.2,1.2c0,0.67,0.54,1.2,1.2,1.2h9.49 c0.66,0,1.2-0.54,1.2-1.2c0-0.67-0.54-1.2-1.2-1.2H-216.84z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g183",
    transform: "translate(94.6367,363.9238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path185"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-48.37-337.46h-28.01c-0.56,0-1.01-0.45-1.01-1.01s0.45-1.01,1.01-1.01h28.01c0.56,0,1.01,0.45,1.01,1.01 S-47.82-337.46-48.37-337.46z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g187",
    transform: "translate(94.6367,319.4512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path189"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-48.37-286.99h-28.01c-0.56,0-1.01-0.45-1.01-1.01s0.45-1.01,1.01-1.01h28.01c0.56,0,1.01,0.45,1.01,1.01 S-47.82-286.99-48.37-286.99z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g191",
    transform: "translate(263.6597,274.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-217.4-236.53h-5.23c-0.56,0-1.01-0.45-1.01-1.01s0.45-1.01,1.01-1.01h5.23c0.56,0,1.01,0.45,1.01,1.01 S-216.84-236.53-217.4-236.53z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g195",
    transform: "translate(94.6367,274.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path197"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-58.35-236.53h-18.03c-0.56,0-1.01-0.45-1.01-1.01s0.45-1.01,1.01-1.01h18.03c0.56,0,1.01,0.45,1.01,1.01 S-57.79-236.53-58.35-236.53z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g199",
    transform: "translate(94.6367,230.5063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path201"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-64.17-186.06h-12.21c-0.56,0-1.01-0.45-1.01-1.01s0.45-1.01,1.01-1.01h12.21c0.56,0,1.01,0.45,1.01,1.01 S-63.61-186.06-64.17-186.06z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g203",
    transform: "translate(94.6367,186.0342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-64.17-135.59h-12.21c-0.56,0-1.01-0.45-1.01-1.01s0.45-1.01,1.01-1.01h12.21c0.56,0,1.01,0.45,1.01,1.01 S-63.61-135.59-64.17-135.59z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.92f29cdc66c17b958e1b23a24b04de7a.svg";
export { ForwardRef as ReactComponent };